// React Imports
import React, { Component } from "react";

// Package Imports
import { Col, Image } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import { Button as UiButton } from "components";

// Project Imports
import * as images from "constants/Images";
import fetchProductLevelFeature from "./fetchProductLevelFeature";
import fetchProductLevelBenefits from "./fetchProductLevelBenefits";


// CSS Imports
import "./salient-feature-modal.css";
import AuthStore from "../../../login/store/AuthStore";
import { VIEW_SALIENT_FEATURE_CUSTOMIZATION } from "../../../../constants/UserClicksConstant";

const SalientFeatureModal = class SalientFeatureModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      data: { productBenefits: [], productFeatures: [] },
    };
  }

  hideCashFlowTableModal = () => {
    this.setState({ isOpen: false });
  };

  showSalientFeatureModal = async () => {
     //!for save user clicks
     AuthStore.saveUserClicks(VIEW_SALIENT_FEATURE_CUSTOMIZATION)

    this.setState({ isOpen: true });
    let features = fetchProductLevelFeature(this.props.productData);
    let benefits = fetchProductLevelBenefits(this.props.productData);
    this.setState({ productFeatures: features, productBenefits: benefits });
  };

  render() {
    return (
      <div className="cashFlowTableModalDiv salient-feature-container d-flex align-items-center">
        <span
          className="ml-0 ml-md-2 btn text-primary p-0 LA-btn font-size-14 font-size-md-12 font-weight-light"
          onClick={() => this.showSalientFeatureModal()}
        >
          [ View Salient Features ]
        </span>
        <Modal
          show={this.state.isOpen}
          backdrop="static"
          onHide={this.hideCashFlowTableModal}
          as="section"
          className="cashFlowTableModal salient-feature"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          keyboard={false}
        >
          <Modal.Header
            closeButton={false}
            className="pb-0 mx-md-2 border-bottom-0 cashFlow-table-header"
          >
            <div className="d-flex justify-content-between w-100">
              <div className="">
                <span className="font-size-12 font-weight-light text-primary">
                  {this.state.needName}
                </span>
                <p className="font-size-20 font-weight-medium text-primary">
                  {this.props.productName}{" "}
                  <span className="font-size-16 font-weight-medium text-primary">
                    Salient Features
                  </span>
                </p>
              </div>

              <UiButton
                variant=""
                className="d-inline-flex align-self-start justify-content-end p-0 ml-2"
                onClick={() => this.hideCashFlowTableModal()}
              >
                <span className="mr-2 cancel-btn-style">Cancel</span>
                <Image className="close-icon-class" src={images.CrossIcon} />
              </UiButton>
            </div>
          </Modal.Header>

          <ModalBody className="cashFlowTableModalBody">
            <section className="h-100">
              {this.state.productBenefits?.length > 0 && (
                <div className="row cashFlowTableModalContent h-100 mb-4">
                  <Col className="col-12 col-md-6 border-right border-2">
                    <span className="font-size-16 font-weight-medium text-primary d-block text-center">
                      Features
                    </span>
                    <div className="row">
                      {this.state.productFeatures?.map((item, index) => {
                        return (
                          <Col key={index} className="col-md-12 col-12 ">
                            <div className="d-flex align-items-baseline ml-2">
                              {index + 1}.
                              <div className="solution-desktop-bg-style d-inline-block w-100 px-sm-3 pt-4 pt-lg-4">
                                {item.label}
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </div>
                  </Col>
                  <Col className="col-12 col-md-6">
                    <span className="font-size-16 font-weight-medium text-primary d-block text-center">
                      Benefits
                    </span>
                    <div className="row">
                      {this.state.productBenefits?.map((item, index) => {
                        return (
                          <Col key={index} className="col-md-12 col-12 ">
                            <div className="d-flex align-items-baseline ml-2">
                              {index + 1}.
                              <div className="solution-desktop-bg-style d-inline-block w-100 px-sm-3 pt-4 pt-lg-4">
                                {item.label}
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </div>
                  </Col>
                </div>
              )}

              {this.state.productBenefits?.length === 0 && (
                <div className="row cashFlowTableModalContent h-100 mb-4">
                  <span className="font-size-16 font-weight-medium text-primary ml-4">
                    Features & Benefits
                  </span>
                  {this.state.productFeatures?.map((item, index) => {
                    return (
                      <Col key={index} className="col-md-12 col-12 ">
                        <div className="d-flex align-items-baseline ml-2">
                          {index + 1}.
                          <div className="solution-desktop-bg-style d-inline-block w-100 px-sm-3 pt-4 pt-lg-4">
                            {item.label}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </div>
              )}
            </section>
          </ModalBody>
        </Modal>
      </div>
    );
  }
};

export default SalientFeatureModal;
